import React, {Fragment} from 'react';

import {Stack} from '@mui/material';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {HighlightedText} from 'presentation/components';
import {SpecialtyDetailsDrawer} from 'presentation/modules/booking/shared/ui/components/SpecialtyDetailsDrawer';
import {translations} from 'presentation/translations-new';
import {useTeleHealthCard} from './hooks/useTeleHealthCard';
import {SelectCardList, StyledButton, StyledIcon} from './styles';
import {CardListProps} from './types';

const {findOutMore} = translations['pt-br'].commons;

export function TeleHealthCard({
	text,
	handleClick,
	dataTagId,
	selected,
	showSpecialtyDetailsButton,
	specialtyCode,
	isSuggestionCard,
	...cardProps
}: CardListProps) {
	const {
		colors,
		query,
		openDetailsDrawerState,
		handleOpenDetailsDrawer,
		handleCloseDetailsDrawer,
	} = useTeleHealthCard();

	return (
		<Fragment>
			<SelectCardList
				{...cardProps}
				elevation={0}
				selected={selected}
				data-tag-id={dataTagId}
				onClick={handleClick}
				sx={{cursor: 'pointer'}}>
				<Stack p={2} gap={1} direction="row" alignItems="center">
					<Stack gap={0.5}>
						<HighlightedText
							text={text}
							highlight={query}
							dataTagId={
								isSuggestionCard
									? AppointmentBookingEnum.SELECIONOU_ESPECIALIDADE_SUGERIDA_TEXT
									: AppointmentBookingEnum.SELECIONOU_ESPECIALIDADE_TEXT
							}
						/>

						{showSpecialtyDetailsButton ? (
							<StyledButton
								data-tag-id={
									AppointmentBookingEnum.CLICK_SABER_MAIS_DESCRICAO_ESPECIALIDADE
								}
								variant="text"
								size="small"
								onClick={event => {
									event.stopPropagation();
									handleOpenDetailsDrawer();
								}}>
								{findOutMore}
							</StyledButton>
						) : null}
					</Stack>
					<Stack flex={1} justifyContent={'center'} height={'100%'}>
						<StyledIcon
							name="arrow-right"
							size={24}
							color={selected ? colors.light.success.main : colors.brand.primary.blue}
						/>
					</Stack>
				</Stack>
			</SelectCardList>

			{openDetailsDrawerState ? (
				<SpecialtyDetailsDrawer
					isOpen={openDetailsDrawerState}
					onClose={handleCloseDetailsDrawer}
					onOpen={handleOpenDetailsDrawer}
					specialtyName={text}
					specialtyCode={specialtyCode}
				/>
			) : null}
		</Fragment>
	);
}
